import MemberList from "../../Collection/MemberList";

export default function UsersTab(props) {
    return (
        <MemberList collection={props.collection.id} />
    )
}